import { useTranslation } from "react-i18next";
import { LandingProductCurrencyEnum, NewsletterRecurringIntervalEnum } from "@dev/ee-api/ee-api-models";
import i18n from '@/../i18n';

interface ProductCurrencySettings {
    prefix: string,
    label: string,
    value: LandingProductCurrencyEnum,
}

interface GetProductCurrencySettings {
    getProductCurrencySettings: (currency: LandingProductCurrencyEnum | string) => ProductCurrencySettings
    formatProductPrice: (currency: LandingProductCurrencyEnum | string, price: number, frequency?: NewsletterRecurringIntervalEnum) => string
}

const getFrequencyTranslation = (frequency: NewsletterRecurringIntervalEnum): string => {
    switch(frequency) {
        case NewsletterRecurringIntervalEnum.Monthly:
            return i18n.t('paid_monthly');
        case NewsletterRecurringIntervalEnum.Quarterly:
            return i18n.t('paid_quarterly');
        case NewsletterRecurringIntervalEnum.Yearly:
            return i18n.t('paid_yearly');
        default:
            return '';
    }
};

export const useGetProductCurrencySettings = (): GetProductCurrencySettings => {
    const { t } = useTranslation();
    const getProductCurrencySettings = (currency: LandingProductCurrencyEnum | string): ProductCurrencySettings => {
        switch(currency) {
            case LandingProductCurrencyEnum.AUD:
                return {
                    prefix: "$ AUD",
                    label: t('currencyaustraliandollar'),
                    value: LandingProductCurrencyEnum.AUD,
                };
            case LandingProductCurrencyEnum.CAD:
                return {
                    prefix: "$ CAD",
                    label: t('currencycanadiandollar'),
                    value: LandingProductCurrencyEnum.AUD,
                };
            case LandingProductCurrencyEnum.EUR:
                return {
                    prefix: "€ EUR",
                    label: t('currencyeuro'),
                    value: LandingProductCurrencyEnum.EUR,
                };
            case LandingProductCurrencyEnum.NZD:
                return {
                    prefix: "$ NZD",
                    label: t('currencynewzealanddollar'),
                    value: LandingProductCurrencyEnum.NZD
                };
            case LandingProductCurrencyEnum.PLN:
                return {
                    prefix: "zł PLN",
                    label: t('currencypolishzloty'),
                    value: LandingProductCurrencyEnum.PLN
                }
            case LandingProductCurrencyEnum.GBP:
                return {
                    prefix: "£ GBP",
                    label: t('currencypoundsterling'),
                    value: LandingProductCurrencyEnum.GBP
                };
            default: {
                return {
                    prefix: "$ USD",
                    label: t('currencyusdollar'),
                    value: LandingProductCurrencyEnum.USD
                }
            }
        }
    };
    const formatProductPrice = (currency: LandingProductCurrencyEnum | string, price: number, frequency?: NewsletterRecurringIntervalEnum) => 
        [
            new Intl.NumberFormat(i18n.language || 'en', { style: 'currency', currency }).format(price),
            ...(frequency ? [getFrequencyTranslation(frequency)] : [])
        ].join(' ');
    
    return { getProductCurrencySettings, formatProductPrice }
}
